// Way to get value properties in deeply nested objects without error exceptions
const getValue = (obj, level, ...rest) => {
  if (obj === null) return null;
  if (obj === undefined) return null;
  // eslint-disable-next-line no-prototype-builtins
  if (rest.length === 0 && obj.hasOwnProperty(level)) return obj[level];
  return getValue(obj[level], ...rest);
};

export default getValue;
